import React from 'react';
import Lottie from 'lottie-react';
import animationData from './Crown_animation.json';
import "./Crown_animation.css";

function Crown_animation() {
  return (
    <section className='Crown_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  );
}

export default Crown_animation;